export function scrollToFragment(fragment: string, retries = 20, delayMs = 50): void {
  const id = fragment.replace(/^#/, '');
  const el = document.getElementById(id);

  if (el) {
    const isAligned = Math.abs(el.getBoundingClientRect().top) <= 120;
    if (!isAligned) {
      el.scrollIntoView({ behavior: retries < 10 ? 'auto' : 'smooth', block: 'start' });
    }

    if (!isAligned && retries > 0) {
      setTimeout(() => scrollToFragment(fragment, retries - 1, delayMs), delayMs);
    }
    return;
  }

  if (retries > 0) {
    setTimeout(() => scrollToFragment(fragment, retries - 1, delayMs), delayMs);
  }
}
